<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { getBinaryProgressLabelByValue, useProgressCell } from '@/utils/element-progress'
import { CHECKIN_ENTITY_KEYS } from '@/utils/entity-keys'
import { isBinaryProgress } from '@/utils/okr-element-values'

defineOptions({
  name: 'CheckinChangedValue'
})

const props = defineProps({
  data: {
    type: Object,
    required: true
  },

  okrElement: {
    type: Object,
    default: () => ({})
  }
})

const { displayValue: getDisplayValue } = useProgressCell({
  data: () => props.data
})

const { t } = useI18n()

const isBinary = computed(() => {
  return isBinaryProgress({
    element: props.okrElement
  })
})

const displayValue = computed(() => {
  if (isBinary.value) {
    const label = getBinaryProgressLabelByValue(props.data[CHECKIN_ENTITY_KEYS.VALUE])

    return t(label)
  }

  return getDisplayValue.value
})

const testId = computed(() => {
  return `${props.data[CHECKIN_ENTITY_KEYS.OUTDATED] ? 'old' : 'new'}-value`
})
</script>

<template>
  <div
    :class="{
      'cc-Value-outdated': data[CHECKIN_ENTITY_KEYS.OUTDATED]
    }"
    :data-auto-testid="testId"
    :data-testid="testId"
    class="cc-Value"
  >
    <slot> {{ displayValue }}</slot>
  </div>
</template>

<style lang="scss" scoped>
.cc-Value {
  font-size: $fs-14;
  line-height: 16px;

  &:not(&-outdated) {
    color: $dark-1;
    font-weight: fw('bold');
  }

  &-outdated {
    color: $grey-1-next;
    font-weight: fw('semi-bold');
  }
}
</style>
